const pleaseWaitText = t('please_wait', 'javascript.loading_screen')

function showLoadingScreen(text=pleaseWaitText) {
  $('#loading-text').html(text)
  $('#loading-overlay').attr('hidden', false)
}

function hideLoadingScreen() {
  $('#loading-text').html('Lūdzu uzgaidi...')
  $('#loading-overlay').attr('hidden', true)
}

export {showLoadingScreen, hideLoadingScreen}